import { AppData } from '@/types/app';
import {
  ListingAppContext,
  ListingAppContextData,
  useTranslationService,
} from '@showclix-shared/ListingComponents';
import { AppDataContext } from './contexts/AppData';
import {
  EmbedControlProvider,
  EmbedControlWrapper,
} from './contexts/EmbedControl';
import { HomeView } from './views/home';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { LoginView } from './views/login';
import { useCallback, useEffect } from 'react';
import { useAppDispatch } from './hooks/useAppDispatch';
import { setTotalEvents } from './store/slices/events';
import { PATH_HOME, PATH_LOGIN } from './constants/pathConstatnts';
import { useAppSelector } from './hooks/useAppSelector';
import { useTimer } from './hooks/useTimer';
import { reservationEndTimeSelector } from './store/selectors/reservation';
import { clearReservation } from './store/slices/reservation';

type AppProps = { data: AppData };

function App({ data }: AppProps) {
  const { t } = useTranslationService(data.translations, 'multievent_listing');
  const dispatch = useAppDispatch();

  // Clear reservation data from multi listing store if reservation is expired
  // This way multi listing doesn't need to wait untill children listings loads
  const reservationEndTime = useAppSelector(reservationEndTimeSelector);

  const onTimerEnd = useCallback(() => {
    dispatch(clearReservation());
  }, [dispatch, clearReservation]);

  useTimer({
    unixDeadline: reservationEndTime,
    onEnd: onTimerEnd,
  });

  // Pass real data
  const contextData: ListingAppContextData = {
    apiUrl: '',
    sellerShortName: 'showclix',
    t,
    locale: 'en-US',
  };

  useEffect(() => {
    dispatch(setTotalEvents({ totalEvents: (data.listings || []).length }));
  }, [data]);

  return (
    <EmbedControlProvider>
      <EmbedControlWrapper />
      <AppDataContext.Provider value={data}>
        <ListingAppContext.Provider value={contextData}>
          <HashRouter>
            <Routes>
              <Route
                path={PATH_HOME}
                element={<HomeView listings={data.listings} />}
              >
                <Route path={PATH_LOGIN} element={<LoginView />} />
              </Route>
            </Routes>
          </HashRouter>
        </ListingAppContext.Provider>
      </AppDataContext.Provider>
    </EmbedControlProvider>
  );
}

export default App;
